import React, { Component } from 'react';
import { compose, withProps } from "recompose";
import { Container, Row, Col, Card, CardBody, CardTitle, CardSubtitle, CardText, Input, Alert, Button, Label, Form, FormGroup, CustomInput, UncontrolledAlert } from "reactstrap";
import { MDBDataTableV5 } from "mdbreact";
import S3 from 'react-aws-s3';
import Moment from 'moment';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
// Components
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow
  } from "react-google-maps";

import { testimonyFormOptionsUrl, internmentUrl, internmentMetaDataUrl } from '../../helpers/url';

const defaultLocation = { lat: 41.712775, lng: 86.005973 };

const MyMapComponent = compose(
    withProps({
      googleMapURL:
        "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places",
      loadingElement: <div style={{ height: `100%` }} />,
      containerElement: <div style={{ height: `400px` }} />,
      mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
  )(props => (
    <GoogleMap
      defaultZoom={5}
      defaultCenter={props.markerposition}
    >
      {props.isMarkerShown && (
        <Marker
          title="Marker"
          position={props.markerposition}
        >
          <InfoWindow options={{ maxWidth: 200 }}>
              <span>Facility Location</span>
          </InfoWindow>
        </Marker>
      )}
    </GoogleMap>
  ));

class FacilityDetail extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "Facilities", link : "#" },
                { title : "Facility Details", link : "#" },
            ],
            loading: false,
            success: false,
            successMessage: "",
            error: false,
            errorMessage: "",
            errorStatusCode: 0,

            isMarkerShown: true,
            latitude: 0,
            longitude: 0,
            markerposition: defaultLocation,
            observation: "",
            locationInfo: {},

            fileUploading: false,
            fileSuccess: false,

            options: {
                columns: [
                    { label: "ID", field: "metaId", sort: "asc", width: 20 },
                    { label: "Title", field: "metaTitle", sort: "asc", width: 50 },
                    { label: "Clarification", field: "metaDescription", sort: "asc", width: 50 },
                    { label: "Remarks", field: "metaRemarks", sort: "asc", width: 50 },
                    { label: "Date", field: "metaDate", sort: "asc", width: 50 },
                    { label: "Category", field: "metaCategory", sort: "asc", width: 50 },
                    { label: "Value", field: "metaValue", sort: "disabled", width: 50 },
                ],
                rows: []
            },
              
        }
        this.metaDataAdd = this.metaDataAdd.bind(this);
    }
    
    componentDidMount() {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = authUser.jwtToken
        this.setState({ facilityId: this.props.location.state.facilityId, loading: false })

        let formFieldData = fetch(testimonyFormOptionsUrl, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken },
		}).then(res => res.json());

        let fetchData = fetch(internmentUrl+this.props.location.state.facilityId, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())

        let fetchMetaData = fetch(internmentMetaDataUrl+this.props.location.state.facilityId, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        
        Promise.all([fetchData, fetchMetaData, formFieldData])
        .then(([data, metadata, formFieldDataOutput]) => {

            var tableRows = {...this.state.options}
            tableRows.rows = metadata

            this.setState({
                landCodes: formFieldDataOutput.landCodes,
                metadataTypes: formFieldDataOutput.metadataTypes,
                facilityTypes: formFieldDataOutput.internmentTypes
            });

            const listItems = formFieldDataOutput.internmentTags.map(item => ({
                value: item.abbr,
                label: item.tagName,
              }));
           
            this.setState({
                data: data,
                metadata: metadata,
                options: tableRows,
                facilityTags: listItems 
            })
        })
        .then(this.setState({loading: false}))
        .catch(err => {
            console.log("error", err)
        })
    }


    ///////////////////////////////// ADDING METADATA

    detailState = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    metaDataAdd(event) {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = authUser.jwtToken
		const userId = authUser.payload.sub;
        var unixTimestamp = new Date(this.state.metadate).getTime() / 1000;

        fetch(internmentMetaDataUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                metaId: 0,
                facilityId: this.state.facilityId,
                metaValue: this.state.metavalue,
                metaDate: unixTimestamp,
                metaTitle: this.state.metatitle,
                metaDescription: this.state.metadescription,
                metaRemarks: this.state.metaremarks,
                metaCaption: this.state.metacaption,
                metaKeywords: this.state.metakeywords,
                metaCategory: this.state.metacategory,
                metaReference: this.state.metareference,
                userId: userId
            })
        }).then(res => res.json())
        .then(data => {
            if(data == 0){
                console.log("Error occured while storing metadata");
                return;
            }

            this.state.options.rows.push({
                metaId: data,
                metaValue: this.state.metavalue,
                metaDate: unixTimestamp,
                metaTitle: this.state.metatitle,
                metaDescription: this.state.metadescription,
                metaRemarks: this.state.metaremarks,
                metaCategory: this.state.metacategory
            })

            this.setState({
                successAdded: true
            });
           
        })
        event.preventDefault();
    }

    fileAutoSubmitToS3 = async (event) => {
        this.setState({
            fileUploading: true
        })
        Moment.locale('en');
        let dt = new Date
        let date = Moment(dt).format('YYYY-MM-DD')
        let file = event.target.files[0]
        let fileName = "facility/" + this.state.facilityId + "/" + this.state.category  + this.state.subfolder + "/" + date + "/" + event.target.files[0].name;

        this.setState({
            fileName: event.target.files[0].name
        })

        console.log(fileName)

        const config = {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID
        };
        const ReactS3Client = new S3(config);

        await ReactS3Client.uploadFile(file, fileName)
        .then((data) => {
             this.setState({
                 fileLocation: data.location,
                 fileSuccess: true,
                 fileUploading: false
             })}
        )
        .catch((err) => {
            this.setState({
                error: true,
                errorMsg: "Failed: " + err
            })}
        )
        
    }

        
    
    render() {
        if (this.state.error) {
            console.log("error")
        }
        else if (this.state.loading === true || this.state.data === undefined) {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid className='text-center'>
                            <h1 className="h3 mb-3 text-center">Loading ...</h1>
                            <div role="status" class="me-2 spinner-border text-info"><span class="sr-only">Loading...</span></div>
                        </Container>
                    </div>
                </React.Fragment>
            )
        }
        else {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Facility Details" breadcrumbItems={this.state.breadcrumbItems} />
 
                        <Row>
                            <Col xs={12} className="mb-4">
                                
                                    <Card>
                                        <CardBody>
                                            <CardTitle>{this.state.data[0].facilityInternalId}: {this.state.data[0].facilityName}</CardTitle>
                                            <CardSubtitle className="mb-3">Urumchi city, Urumchi perfecture</CardSubtitle>
                                        </CardBody>
                                            <MyMapComponent
                                            isMarkerShown={this.state.isMarkerShown}
                                            latitude={this.state.latitude}
                                            longtitude={this.state.longitude}
                                            markerposition = {this.state.markerposition}
                                        />
                                        <CardBody>
                                            <CardText>
                                                Internal facility id: {this.state.data[0].facilityInternalId} with reference: REF-{this.state.data[0].facilityId} is located DMS {this.state.data[0].degree ? this.state.data[0].degree : "unknown"} DD  {this.state.data[0].geolocation ? this.state.data[0].geolocation : "unknown"}
                                            </CardText>
                                            <CardText>
                                               Remarks: {this.state.data[0].remarks}
                                            </CardText>
                                            <CardText>
                                                <small className="text-muted">Last updated x mins ago</small>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                    <Card>
                                        <CardBody>
                                
                                        <FormGroup row className="mb-0" >
                                            <Label className="col-md-2 col-form-label">Category</Label>
                                            <Col md={10}>
                                            <select className="custom-select" id="category" placeholder="pick" onChange={this.detailState}>
                                                <option defaultValue value="notdefined">Select category</option>
                                                <option value="main-img">Display Image</option>
                                                <option value="video">Video</option>
                                                <option value="ground">Ground</option>
                                                <option value="documents">Documents</option>
                                                <option value="files">Files</option>
                                                <option value="maps">Maps</option>
                                                <option value="research">Research Paper</option>
                                                <option value="3d">Camp 3D Model</option>
                                                <option value="others">Others</option>
                                            </select>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="mb-0" >
                                            <Label className="col-md-2 col-form-label">Subfolder</Label>
                                            <Col md={10}>
                                                <Input className="form-control" type="text" placeholder="/subfolder" id="subfolder" onChange={this.detailState}/>
                                                <p className="card-title-desc"> Please provide subfolder if required. Has to follow strictly following rule  Ex:<em>/subfolder</em>. Each subfolder has to start / sign followed by name for subfolder </p>
                                            </Col>
                                        </FormGroup>
                                        </CardBody>
                                        <CardBody>
                                    
                                            <h4 className="card-title">File browser</h4>
                                            <p className="card-title-desc">Please  <em>Choose file…</em> to upload to server. Big size file require some time please await it completes uploading. The data submitted here is not meta data related files.</p>
                                            <div className="custom-file mb-4">
                                                <CustomInput type="file" className="custom-file-input" id="customFile" onChange={this.fileAutoSubmitToS3}/>
                                                <Label className="custom-file-label" htmlFor="customFile">Choose file</Label>
                                                {this.state.fileUploading ? <div role="status" class="me-2 spinner-border text-info"><span class="sr-only">Loading...</span></div> : ""}
                                            
                                                <Alert color="success" isOpen={this.state.fileSuccess} >
                                                {this.state.fileName} uploaded
                                                </Alert>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <Card>
                                        
                                        <CardBody>
                                            <CardTitle className="mt-0">Facility Data</CardTitle>
                                            <CardText>Additional content.</CardText>

                                            <h4 className="card-title">Meta Data</h4>
                                                    <p className="card-title-desc">Fill all information below. You can add multiple meta data.</p>

                                                    <Form id="meta-data-form">
                                                        <Row>
                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metatitle">Meta title</Label>
                                                                    <Input id="metatitle" name="metatitle" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                                
                                                            </Col>
                    
                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metacaption">Meta Caption</Label>
                                                                    <Input id="metacaption" name="metacaption" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metacategory">Category</Label>
                                                                    <select className="custom-select" id="metacategory" placeholder="pick" onChange={this.detailState}>
                                                                        <option defaultValue value="0">Select category</option>
                                                                        {this.state.metadataTypes.map((data, id) => (
																			<option key={id} value={data.metadataId}>
																				{data.metadataType}  {data.metadataUnit !== null ? "("+data.metadataUnit+")" : "" }
																			</option>
																		))}
                                                                    </select>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metavalue">Value</Label>
                                                                    <Input id="metavalue" name="metavalue" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metadate">Date</Label>
                                                                    <Input
                                                                        type="date"
                                                                        name="metadate"
                                                                        id="metadate"
                                                                        placeholder="Date: YYYY-MM-DD"
                                                                        onChange={this.handleChange}
                                                                        value={this.state.value}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metareference">Reference</Label>
                                                                    <Input id="metareference" name="metareference" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>

                                                        <FormGroup>
                                                            <Label htmlFor="metadescription">Meta Clarification</Label>
                                                            <textarea className="form-control" id="metadescription" rows="5" onChange={this.detailState}></textarea>
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Label htmlFor="metaremarks">Meta Remarks</Label>
                                                            <textarea className="form-control" id="metaremarks" rows="5" onChange={this.detailState}></textarea>
                                                        </FormGroup>
                                                    </Form>

                                                    {this.state.successAdded ? <UncontrolledAlert color="success" role="alert">
                                                        The metadata successfully added!
                                                    </UncontrolledAlert> : ""}

                                                    <div className="text-center mt-4">
                                                        <Button color="primary" type="button" className="mr-2 waves-effect waves-light" onClick={this.metaDataAdd}>Save Changes</Button>
                                                        <Button color="light" type="button" className="waves-effect ml-1">Cancel</Button>
                                                    </div>
                                            
                                            <CardText>
                                                <small className="text-muted">* General Info</small>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="mt-0">Facility Metadata</CardTitle>
                                        <CardText>Below is the list of total {this.state.metadata.length} metadata collected for this Facility. The maximum possible number of types each facility may have up to 70 variables</CardText>
                                        
                                        <MDBDataTableV5 
                                            hover
                                            entriesOptions={[10, 15, 25, 50]} 
                                            responsive 
                                            filter='vdid' // needs pro version
                                            entries={15} 
                                            pagesAmount={10} 
                                            data={this.state.options} 
                                            searchTop 
                                            searchBottom={false}
                                        />
                                        
                                        <CardText>
                                            <small className="text-muted">Information here is just for the presentation. Request for details.</small>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}
}

export default FacilityDetail;